import React, { ImgHTMLAttributes } from "react";

import SEO from "../components/seo";
import { PageLayout } from '../components/PageLayout';
import { FAQBox, PageHeader, ListItem, StepBox, IconStepBox, BulletItem } from '../components/SubpageComponents';
import { navigate } from 'gatsby';
import { fileAndForget } from '../common/utl/ErrUtl';
import
{
  DotsIcon, InsuranceIcon, OptionIcon, MoneyIcon,
  Dots2Icon, PhoneIcon, MailIcon, Dots4Icon, DocumentIcon,
  WebIcon, Phone2Icon, PostMailIcon, Mail2Icon, HomeIcon, FacebookIcon, InstagramIcon, LinkedinIcon,
} from '../components/svg/Icons';
import { Button } from 'react-bootstrap';
import { envBrandPZlow, envBrandWDB, helpMail, helpPhone1, helpPhone2 } from '../model/Const';
import { prettyPrintPLPhoneNumber } from '../common/utl/PhoneNumberUtils';
import { VariantChoice } from '../components/policy/VariantChoice';
import { Info } from '../components/Info';
import { PublicBucketUrl, ProductCardPath, OWUEduPlusPath, AmendmentsPath, ClaimFormPath, HateStopPath } from '../model/consent/Consent';
import { addAffiliateCode } from '../components/AffiliateLink';

const maxWStyle = { maxWidth: 1024 };
const loadLazily: ImgHTMLAttributes<any> = { loading: 'lazy' };

const IndexPage: React.FunctionComponent<{}> = () =>
{
  return (<PageLayout>
    <SEO title="NNW" />
    <div className="mb-3 position-relative only-desktop">
      <div className="cropPhoto" style={{ height: 368 }}>
        {envBrandWDB && <img src="/img/photo01-90.jpg" {...loadLazily} />}
        {envBrandPZlow && <img src="/img/pzlow/Photo 01.png" {...loadLazily} />}
      </div>
      {envBrandWDB && <img src="/img/boy.png" style={{ position: 'absolute', top: '12%', height: '95%', left: '28%' }} />}
      {envBrandPZlow && <img src="/img/pzlow/Girl.png" style={{ position: 'absolute', top: '12%', height: '95%', left: '28%' }} />}
      <DotsIcon style={{ position: 'absolute', top: 'calc(100% + 26px)', width: 302, height: 136, left: '26px' }} />
      <div style={
        {
          position: 'absolute', top: '10%', width: 600, left: 'calc(50% + 50px)', color: '#f9f5f5',
          textAlign: 'left',
          textShadow: '0 0 40px white',
        }} >
        <div className="fw-600 fs-25 mb-4">
          Więcej niż NNW szkolne dla Twojego dziecka
        </div>
        <div className="fw-400 fs-16 lh-28">
          <BulletItem className="mt-0">
            różne warianty do wyboru
          </BulletItem>
          <BulletItem className="mt-0">
            ochrona w trybie 24/7
          </BulletItem>
          <BulletItem className="mt-0">
            dla dzieci i młodzieży od narodzin do 25 r.ż. <Info>
              Ubezpieczonym może być osoba ucząca się, która nie ukończyła jeszcze 25 roku życia, lub osoba do 18 roku życia która zakończyła już proces edukacji
            </Info>
          </BulletItem>
          <BulletItem className="mt-0">
            {envBrandWDB && <>sporty wyczynowe i ekstremalne</>}
            {envBrandPZlow && <>sporty wyczynowe i ekstremalne, w tym strzelectwo sportowe</>}
          </BulletItem>
        </div>
        <div>
          <Button
            id="varChoose"
            variant="primary"
            className="mt-3"
            style={
              {
                textShadow: 'none',
                width: 190,
                padding: 11,
              }}
            onClick={() =>
            {
              navigate(addAffiliateCode('/nnw-dziecka/kup-ubezpieczenie'))?.catch(fileAndForget);
            }}
          >
            WYBIERZ WARIANT
          </Button>
        </div>
      </div>
    </div>

    <div
      className="mb-3 position-relative only-mobile d-flex justify-content-center"
      style={{ marginLeft: '-1rem' }}
    >
      {envBrandWDB && <img src="/img/Photo 01 mobile.jpg" {...loadLazily} />}
      {envBrandWDB && <img src="/img/boy.png" style={{ position: 'absolute', top: '39%', height: '65%', left: '50%' }} />}
      {envBrandPZlow && <img src="/img/pzlow/Photo 01 mobile.png" {...loadLazily} />}
      {envBrandPZlow && <img src="/img/pzlow/Girl.png" style={{ position: 'absolute', top: '39%', height: '65%', left: '50%' }} />}
    </div>
    <div
      className="only-mobile pt-3"
      style={
        {
          textAlign: 'left',
          textShadow: '0 0 40px white',
        }} >
      <div className="fw-600 fs-25 mb-4 mt-5 text-center">
        Więcej niż NNW szkolne dla Twojego dziecka
      </div>
      <div className="fw-400 fs-16 lh-28">
        <BulletItem className="mt-0">
          różne warianty do wyboru
        </BulletItem>
        <BulletItem className="mt-0">
          ochrona w trybie 24/7
        </BulletItem>
        <BulletItem className="mt-0">
          dla dzieci i młodzieży od narodzin do 25 r.ż. <Info>
            Ubezpieczonym może być osoba ucząca się, która nie ukończyła jeszcze 25 roku życia, lub osoba do 18 roku życia która zakończyła już proces edukacji
          </Info>
        </BulletItem>
        <BulletItem className="mt-0">
          {envBrandWDB && <>sporty wyczynowe i ekstremalne</>}
          {envBrandPZlow && <>sporty wyczynowe i ekstremalne, w tym strzelectwo sportowe</>}
        </BulletItem>
      </div>
      <DokumentyMobile />
    </div>


    <div className="d-flex align-items-center flex-column w-100">
      <div className="only-desktop">
        <DlaczegoWarto />
      </div>
      <div id="zakres-ubezpieczenia" className="sticky-anchor only-desktop">
        <PageHeader className="text-center mt-5 pt-2">
          Ubezpieczenie od Następstw Nieszczęśliwych Wypadków
        </PageHeader>
        <div
          className="text-center fs-18 fw-400"
        >
          Warianty ochrony do wyboru
        </div>
      </div>
      <div style={maxWStyle}>
        <VariantChoice
          onChoice={() => navigate(addAffiliateCode('/nnw-dziecka/kup-ubezpieczenie'))?.catch(fileAndForget)}
        />
      </div>
      <div className="mt-4 position-relative w-100 only-desktop">
        <div className="cropPhoto" style={{ height: 411 }}>
          {envBrandWDB && <img src="/img/photo02.jpg" {...loadLazily} />}
          {envBrandPZlow && <img src="/img/pzlow/Photo 02.png" {...loadLazily} />}
        </div>
        <Dots4Icon style={{ position: 'absolute', top: 'calc(100% + 26px)', width: 302, height: 71, left: '75%' }} />
        <div style={
          {
            position: 'absolute', top: 'calc(50% - 58px)', width: 600, left: '13%', color: '#f9f5f5',
            textAlign: 'left',

          }} >
          <div className="fw-600 fs-25 mb-4">
            W przypadku pytań związanych z ubezpieczeniem NNW Twojego dziecka zachęcamy do kontaktu
          </div>
          <div className="d-flex justify-content-center align-items-center">
            <div className="mr-5 d-flex">
              <PhoneIcon style={{ width: 24, height: 'auto', fill: 'white' }} />
              <div>
                <a
                  style={{ color: 'white' }}
                  className="ml-2"
                  href={'tel:' + helpPhone1}
                >
                  {prettyPrintPLPhoneNumber(helpPhone1)}
                </a>
                <br />
                <a
                  style={{ color: 'white' }}
                  className="ml-2"
                  href={'tel:' + helpPhone2}
                >
                  {prettyPrintPLPhoneNumber(helpPhone2)}
                </a>
              </div>
            </div>
            <div className="mr-2">
              <MailIcon style={{ width: 24, height: 'auto' }} className="fill-white" />
              <a
                style={{ color: 'white' }}
                className="ml-2"
                href={'mailto:' + helpMail}
              >
                {helpMail}
              </a>
            </div>
          </div>
        </div>
      </div>

      <div
        className="mb-3 only-mobile"
        style={{ marginLeft: '-1rem' }}
      >
        {envBrandWDB && <img src="/img/Photo 02 mobile.jpg" {...loadLazily}
          style={{
            margin: 'auto',

          }}
        />}
        {envBrandPZlow &&
          <img src="/img/pzlow/Photo 02 mobile.png" {...loadLazily}
            style={{
              margin: 'auto',

            }}
          />}
      </div>

      <div
        className="only-mobile mt-3"
        style={
          {
            lineHeight: '27px',
            textAlign: 'left',
          }} >
        <div className="mb-4">
          W przypadku jakichkolwiek pytań związanych z ubezpieczeniem NNW Twojego dziecka <strong>zachęcamy do kontaktu</strong>
        </div>
        <div className="">
          <div className="mr-5 d-flex">
            <PhoneIcon style={{ width: 24, height: 'auto', fill: 'var(--yellow-color)' }} />
            <div>
              <a
                className="ml-2"
                href={'tel:' + helpPhone1}
              >
                {prettyPrintPLPhoneNumber(helpPhone1)}
              </a>
              <br />
              <a
                className="ml-2"
                href={'tel:' + helpPhone2}
              >
                {prettyPrintPLPhoneNumber(helpPhone2)}
              </a>
            </div>
          </div>
          <div className="mr-2 mt-3">
            <MailIcon style={{ width: 24, height: 'auto', fill: 'var(--yellow-color)' }} />
            <a
              className="ml-2"
              href={'mailto:' + helpMail}
            >
              {helpMail}
            </a>
          </div>
        </div>
      </div>


      <div style={maxWStyle}>
        <div className="my-5" />
        <div className="only-mobile">
          <DlaczegoWarto />
        </div>
        <div className="my-5" />
        <Likwidacja />
        <div className="my-5" />
        <FAQ />
        <div className="my-5" />
        <Dokumenty />
        <div className="my-5" />
        <OFundacji />
        <div className="my-5" />
        <OWDB />
        <div className="my-5" />

      </div>
    </div>
    <div className="my-3" />
  </PageLayout>);
};

function Dokumenty()
{
  return (
    <div id="dokumenty" className="sticky-anchor">
      <PageHeader className="text-center text-red">
        Dokumenty
      </PageHeader>
      <div className="d-flex mb-3">
        <div className="mr-2">
          <DocumentIcon style={{ width: 24, height: 32, fill: 'var(--yellow-color)' }} />
        </div>
        <a target="_blank" href={`${PublicBucketUrl}${OWUEduPlusPath}`}>
          <span>
            Ogólne Warunki Ubezpieczenia EDU Plus zatwierdzonych Uchwałą nr 01/25/03/2022 Zarządu InterRisk S.A. Vienna Insurance Group z dnia 25.03.2022 r.
          </span>
        </a>
      </div>
      <div className="d-flex mb-3">
        <div className="mr-2">
          <DocumentIcon style={{ width: 24, height: 32, fill: 'var(--yellow-color)' }} />
        </div>
        <a target="_blank" href={`${PublicBucketUrl}${AmendmentsPath}`}>
          <span>
            Postanowienia dodatkowe i odmienne od OWU EDU Plus zatwierdzonych Uchwałą nr 01/25/03/2022 Zarządu InterRisk S.A. Vienna Insurance Group z dnia 25.03.2022 r.
          </span>
        </a>
      </div>
      <div className="d-flex mb-3">
        <div className="mr-2">
          <DocumentIcon style={{ width: 24, height: 32, fill: 'var(--yellow-color)' }} />
        </div>
        <a target="_blank" href={`${PublicBucketUrl}${HateStopPath}`}>
          <span>
            Szczegółowy zakres Opcji HEJT STOP
          </span>
        </a>
      </div>
    </div>
  );
}

function DokumentyMobile()
{
  return (
    <div id="dokumentyMobile" className="sticky-anchor mt-3">
      <table className="w-100"><tr>
        <td className="text-center w-50">
          <a target="_blank" href={`${PublicBucketUrl}${OWUEduPlusPath}`}>
            <DocumentIcon style={{ width: 24, height: 32, fill: 'var(--yellow-color)' }} />
            <br /><span>OWU</span>
            <br /><span>EDU Plus</span>
          </a>
        </td>
        <td className="text-center w-50">
          <a target="_blank" href={`${PublicBucketUrl}${ProductCardPath}`}>
            <DocumentIcon style={{ width: 24, height: 32, fill: 'var(--yellow-color)' }} />
            <br /><span>Karta</span>
            <br /><span>Produktu</span>
          </a>
        </td>
      </tr></table>
    </div>
  );
}

function DlaczegoWarto()
{
  return (
    <div style={maxWStyle}>

      <PageHeader className="text-center mb-4 pb-2">
        Zobacz, dlaczego warto ubezpieczyć dziecko
      </PageHeader>

      <div className="d-flex justify-content-around mobile-center">
        <div className="d-flex flex-column reasonBox">
          <div className="d-flex justify-content-center mt-5 mb-3">
            <InsuranceIcon style={{ width: 72, height: 70 }} />
          </div>
          <div style={{ textAlign: 'center' }} className="p-3">
            Ochrona ubezpieczeniowa 365 dni w roku na całym świecie. W&nbsp;trakcie zajęć szkolnych, w czasie wolnym, na feriach i wakacjach.
          </div>
        </div>
        <div className="d-flex flex-column reasonBox">
          <div className="d-flex justify-content-center mt-5 mb-3">
            <OptionIcon style={{ width: 72, height: 70 }} />
          </div>
          <div style={{ textAlign: 'center' }} className="p-3">
            Do wyboru trzy warianty ochrony zróżnicowane pod względem składki, zakresu oraz Sumy&nbsp;Ubezpieczenia.
          </div>
        </div>
        <div className="d-flex flex-column reasonBox position-relative">
          <div className="d-flex justify-content-center mt-5 mb-3">
            <MoneyIcon style={{ width: 72, height: 70 }} />
          </div>
          <div style={{ textAlign: 'center' }} className="p-3">
            Wypłata świadczenia po zgłoszeniu roszczenia – bez wymogu zakończenia leczenia.
          </div>
          <Dots2Icon className="only-desktop" style={{ position: 'absolute', top: '30%', width: 42, height: 115, left: 'calc(100% + 26px)' }} />
        </div>
      </div>
    </div>
  );
}

function OFundacji()
{
  return (
    <div id="o-fundacji" className="sticky-anchor text-justify">
      <PageHeader className="text-center text-red">
        Fundacja PolskieDzieci.org
      </PageHeader>
      <div>
        Od 2016 roku, jako fundacja Polskie Dzieci.org, jesteśmy blisko potrzeb najmłodszych pokoleń.
        Wychodzimy z założenia, że&nbsp;kiedy dorastają, to właśnie od nas, dorosłych,
        powinny czerpać wiedzę oraz niezbędne dla zdrowego i szczęśliwego życia nawyki.
        W tym celu jesteśmy aktywni w dwóch kluczowych obszarach:

        <div className="mt-3">
          <ListItem>
            Zajmujemy się promocją i profilaktyką zdrowego trybu życia wśród dzieci,
            młodzieży, pedagogów oraz&nbsp;rodziców na&nbsp;terenie powiatu wrocławskiego.
            Opieramy się na modelu 360, obejmując konkretnymi działaniami wszystkich,
            którzy bezpośrednio wpływają na postawę i żywieniowe wybory dziecka.
            Naszym niewątpliwym sukcesem w tej materii są Zdrowiki&nbsp;-&nbsp;szkolne sklepiki oferujące
            wyłącznie zdrową i smaczną żywność, po którą chętnie sięgają uczniowie.
          </ListItem>
          <ListItem>
            Jako fundacja budujemy wśród dzieci świadomość na temat ubezpieczeń,
            ponieważ wierzymy, że&nbsp;powinniśmy nasze dzieci nie tylko inspirować zdrowiem,
            ale jednocześnie zadbać o to, aby właściwie i realnie je&nbsp;zabezpieczać.
            W tym celu dajemy możliwość zawarcia nowoczesnego ubezpieczenia NNW,
            które dzięki formule easy direct pozwala zaledwie kilkoma kliknięciami chronić
            interes dziecka i jego rodziców na bardzo atrakcyjnych warunkach.
          </ListItem>
        </div>

        <div className="d-flex justify-content-center pt-3">
          <a className="ml-4 mobile-center" href="http://www.polskiedzieci.org" target="_blank">
            <span className="mr-lg-2"><HomeIcon style={{ width: 47, height: 47 }} /></span>WWW
          </a>
          <a className="ml-4 mobile-center" href="https://www.facebook.com/polskiedzieci.org" target="_blank">
            <span className="mr-lg-2"><FacebookIcon style={{ width: 47, height: 47 }} /></span>Facebook
          </a>
          <a className="ml-4 mobile-center" href="https://www.instagram.com/polskie_dzieci" target="_blank">
            <span className="mr-lg-2"><InstagramIcon style={{ width: 47, height: 47 }} /></span>Instagram
          </a>
        </div>
      </div>
    </div>
  );
}

function OWDB()
{
  return (
    <div id="o-wdb" className="sticky-anchor text-justify">
      <PageHeader className="text-center pb-4 text-red">
        WDB S.A.
      </PageHeader>
      <div>
        WDB S.A. Brokerska Grupa Ubezpieczeniowa  jest licencjonowanym brokerem ubezpieczeniowym. Działamy wyłącznie w interesie Klienta, który podejmuje z nami współpracę w ramach obsługi brokerskiej. Duży nacisk kładziemy na doskonalenie, dynamizm oraz rozwój. Nasze wieloletnie doświadczenie jest gwarancją skuteczności i profesjonalizmu, co w konsekwencji buduje przewagę konkurencyjną dla naszych Klientów.
      </div>
      <div className="mt-3">
        Naszym celem jako Spółki jak i całej Grupy Kapitałowej jest dostarczanie rozwiązań, które charakteryzują się
        najwyższą jakością oraz sprawdzoną efektywnością. WDB S.A. Brokerska Grupa Ubezpieczeniowa współpracuje z sektorem
        oświaty już 12 lat. Główną zaletą naszych programów ubezpieczeniowych w ramach NNW jest możliwość dostosowania
        umowy pod względem wysokości składki, zakresu ochrony oraz wysokości sumy ubezpieczenia do potrzeb i możliwości
        Ubezpieczonych. Elementem decyzyjnym w negocjowanych przez WDB programach jest zawsze wysokość sumy ubezpieczenia
        oraz zakres ochrony ubezpieczeniowej. Mając możliwość analizy raportów szkód zgłaszanych przez naszych Klientów,
        staramy się konstruować i negocjować programy ubezpieczeniowe w ten sposób, aby wysokość sumy ubezpieczenia była
        satysfakcjonująca dla poszkodowanych, nawet w przypadku drobnych roszczeń. Suma ubezpieczenia jest jednym z tematów
        szeroko analizowanych w raportach dotyczących ubezpieczeń NNW dla dzieci i młodzieży szkolnej. Według naszej opinii,
        powinna być ona brana pod uwagę jako element kluczowy w podejmowanych decyzjach dotyczących ochrony ubezpieczeniowej.
        Komplet informacji o możliwościach firmy dostępny jest na stronie: <a href="https://www.wdbsa.pl" target="_blank">
          <strong>www.wdbsa.pl</strong></a>
      </div>
      <div className="d-flex justify-content-center pt-3">
        <a className="ml-4 mobile-center" href="https://www.wdbsa.pl" target="_blank">
          <span className="mr-lg-2"><HomeIcon style={{ width: 47, height: 47 }} /></span>WWW
        </a>
        <a className="ml-4 mobile-center" href="https://www.linkedin.com/company/wdbsa/?originalSubdomain=pl" target="_blank">
          <span className="mr-lg-2"><LinkedinIcon style={{ width: 47, height: 47 }} /></span>LinkedIn
        </a>
      </div>
    </div>
  );
}

function Likwidacja()
{
  return (
    <div id="likwidacja" className="sticky-anchor">
      <PageHeader className="text-center text-red">
        Likwidacja szkód
      </PageHeader>
      <div>
        Przed przystąpieniem do zgłoszenia roszczenia z umowy ubezpieczenia <strong>EDU Plus</strong> prosimy o przygotowanie:
      </div>
      <div>
        <StepBox stepNo="1">
          serii i numeru polisy, z której będzie zgłaszane roszczenie
        </StepBox>
        <StepBox stepNo="2">
          danych osobowych Ubezpieczonego
        </StepBox>
        <StepBox stepNo="3">
          numeru rachunku bankowego, na który należy wypłacić odszkodowanie
        </StepBox>
        <StepBox stepNo="4">
          dokumentacji medycznej z przebiegu leczenia
        </StepBox>
      </div>
      <div className="mt-5">
        Przypominamy, iż Ubezpieczającym w programie jest Fundacja Polskiedzieci.org. Informacja ta jest niezbędna do zgłoszenia roszczenia.
      </div>

      <div className="mt-5 fw-600">
        Szkodę można zgłosić na kilka sposobów:
      </div>
      <div>
        <IconStepBox icon={<WebIcon style={{ width: 47, height: 47 }} />}>
          <span className="fw-600">Internetowo</span>
          &nbsp;- za&nbsp;pośrednictwem&nbsp;strony:
          <br />
          <a href="https://zgloszenie.interrisk.pl/assetclaim/new" className="text-yellow force-wrap" target="_blank">
            https://zgloszenie.interrisk.pl/assetclaim/new
          </a>
        </IconStepBox>
        <IconStepBox icon={<Phone2Icon style={{ width: 47, height: 47 }} />}>
          <span className="fw-600">Telefonicznie</span>
          &nbsp;- pod numerem telefonu InterRisk Kontakt:
          <span className="text-yellow"><br />(22) 575 25 25</span>
        </IconStepBox>
        <IconStepBox icon={<PostMailIcon style={{ width: 47, height: 47 }} />}>
          <div>
            <span className="fw-600">Pocztą tradycyjną</span>
            &nbsp;- kompletną dokumentację należy wysłać na poniższy adres:
            <span className="text-yellow ml-2">
              <br />
              Przegr. Pocztowa nr 3334
              <br />
              40-610 Katowice
            </span>
          </div>
        </IconStepBox>
        <IconStepBox icon={<Mail2Icon style={{ width: 47, height: 47 }} />}>
          <div>
            <span className="fw-600">Pocztą elektroniczną</span>
            &nbsp;- skany wymaganych dokumentów (wskazanych w §21 OWU) należy przesłać na adres <span className="text-nowrap">e-mail:</span>
            <br />
            <a href="mailto:szkody@interrisk.pl" className="text-yellow">
              szkody@interrisk.pl
            </a>
          </div>
        </IconStepBox>
      </div>
      <div className="mt-5">
        Druk zgłoszenia roszczenia dostępny jest &nbsp;
        <a className="text-yellow" href={`${PublicBucketUrl}${ClaimFormPath}`} target="_blank">
          tutaj
        </a>
      </div>
      <div className="mt-3">
        W przypadku pytań lub wątpliwości związanych ze zgłoszeniem roszczenia, prosimy o kontakt <span className="text-nowrap">z WDB S.A.:</span>
        <br />
        <span className="text-yellow">
          Dział Obsługi Klienta
        </span>
        <br />
        <a className="text-yellow" href={'tel:' + helpPhone1}>{prettyPrintPLPhoneNumber(helpPhone1, true)}</a>
        <br />
        <a className="text-yellow" href={'tel:' + helpPhone2}>{prettyPrintPLPhoneNumber(helpPhone2, true)}</a>
        <br />
        <a
          className="text-yellow"
          href={'mailto:' + helpMail}
        >
          {helpMail}
        </a>
      </div>

    </div >
  );
}

function FAQ()
{
  return (
    <div id="faq" className="sticky-anchor">
      <PageHeader className="text-center text-red">
        FAQ
      </PageHeader>
      <FAQBox title="W jakim wieku muszą być dzieci, żeby mogły przystąpić do ubezpieczenia?">
        Do ubezpieczenia mogą przystąpić dzieci od momentu narodzin do 18 roku życia (jeśli zakończyły już naukę) lub do 25 roku życia (jeśli wciąż się uczą).
      </FAQBox>
      <FAQBox title="Jak długo trwa ochrona ubezpieczeniowa dziecka?">
        Okres ochrony obejmuje 12 miesięcy. Początkiem ochrony jest wybrana przez osobę zainteresowaną data z zastrzeżeniem, że odpowiedzialność Ubezpieczyciela rozpoczyna się najwcześniej od dnia następnego po zapłaceniu składki za ubezpieczenie. Przed końcem okresu ubezpieczenia przypomnimy o zbliżającym się terminie zakończenia ochrony.
      </FAQBox>
      <FAQBox title="Od czego zależy wysokość składki za ubezpieczenie?">
        Wysokość składki za ubezpieczenie zależy od wybranego wariantu ubezpieczenia oraz ewentualnego rozszerzenia go o SPORTY WYSOKIEGO RYZYKA. Im wyższa składka za ubezpieczenie, tym wyższa Suma Ubezpieczenia oraz szerszy zakres ochrony.
      </FAQBox>
      <FAQBox title="Czy dziecko może być ubezpieczone jednocześnie w ramach kilku polis NNW?">
        Tak. Dziecko może być ubezpieczone w ramach kilku polis ubezpieczenia z zakresu NNW. W momencie zajścia wypadku i wypłaty świadczenia Ubezpieczony otrzyma wypłatę ze wszystkich zawartych polis (o ile dane ryzyko było w nich zawarte).
      </FAQBox>
      <FAQBox title="Czy mogę za jednym razem ubezpieczyć więcej niż jedno dziecko?">
        Tak. Jednorazowo można ubezpieczyć do 10 dzieci. Wszystkie dzieci będą miały tę samą datę początku oraz zakończenia okresu ochrony ubezpieczeniowej, ale dla każdego z dzieci można wybrać inny wariant ubezpieczenia. Każdy z Ubezpieczonych otrzyma indywidualny Certyfikat ubezpieczenia wskazujący wybrany wariant ubezpieczenia oraz okres trwania ochrony.
      </FAQBox>
      <FAQBox title="Czy mogę ubezpieczyć dzieci w różnych wariantach ochrony?">
        Tak. Wybór wariantów jest dowolny i możliwe jest ubezpieczenie poszczególnych dzieci w różnych wariantach ubezpieczenia. Każdy z Ubezpieczonych otrzyma swój indywidualny Certyfikat ubezpieczenia potwierdzający wybrany wariant ochrony oraz jej start i zakończenie.
      </FAQBox>
      <FAQBox title="Czy mogę ubezpieczyć dzieci uczęszczające do różnych placówek oświatowych?">
        Tak. Wybór wariantów jest dowolny i możliwe jest ubezpieczenie poszczególnych dzieci w różnych wariantach ubezpieczenia. Każdy z Ubezpieczonych otrzyma swój indywidualny Certyfikat ubezpieczenia potwierdzający wybrany wariant ochrony oraz okres na jaki ubezpieczone jest dziecko.
      </FAQBox>
      <FAQBox title="Czy otrzymam Polisę Ubezpieczenia, potwierdzającą zawarcie ubezpieczenia?">
        Nie. Polisa Ubezpieczenia wystawiona jest dla Fundacji PolskieDzieci.org, która jest Ubezpieczającym w programie. Każdy Ubezpieczony otrzymuje natomiast Certyfikat Ubezpieczenia, będący dokumentem potwierdzającym ochronę ubezpieczeniową i opisującym na jakich zasadach została ona zawarta.
      </FAQBox>
    </div>
  );
}

export default IndexPage;
